var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.021 10.3931C15.4115 10.0026 15.4115 9.36955 15.021 8.97908C14.6305 8.58862 13.9975 8.58862 13.607 8.97908L5.8199 16.7662C5.29493 17.2912 5 18.0032 5 18.7456C5 18.8861 5.11394 19.0001 5.25448 19.0001C5.99691 19.0001 6.70893 18.7052 7.2339 18.1802L15.021 10.3931ZM16.435 7.56508C16.8255 7.95555 17.4585 7.95555 17.849 7.56508C18.2395 7.17462 18.2395 6.54155 17.849 6.15108C17.4585 5.76062 16.8255 5.76062 16.435 6.15108C16.0445 6.54155 16.0445 7.17462 16.435 7.56508ZM8.12067 20.1215C7.55806 20.684 6.79504 21.0001 5.99942 21.0001H4C3.44772 21.0001 3 20.5524 3 20.0001V17.9997C3 17.2041 3.31607 16.441 3.87868 15.8784L16.435 3.32208C16.6225 3.13461 16.8768 3.0293 17.142 3.0293C17.4072 3.0293 17.6615 3.13461 17.849 3.32208L20.678 6.15108C20.8655 6.33861 20.9708 6.59292 20.9708 6.85808C20.9708 7.12325 20.8655 7.37756 20.678 7.56508L8.12067 20.1215Z",
    fill: "#BCBFC2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.2360926c.svg";
export { ForwardRef as ReactComponent };